const EVENT_NAME_PROP = 'plausible-event-name=click';
const JOBS_SECTION_PROP = 'plausible-event-section=jobs';
const NEWS_SECTION_PROP = 'plausible-event-section=news';
const ORGS_SECTION_PROP = 'plausible-event-section=organizations';
const VIEW_SINGLE_RESULT_INTENTION = 'plausible-event-intention=view-single-result';
const NO_RESULTS_SEE_MORE_INTENTION = 'plausible-event-intention=no-results-see-more';
const SEE_RELATED_RESULTS_INTENTION = 'plausible-event-intention=see-related-results';

export {
  EVENT_NAME_PROP,
  JOBS_SECTION_PROP,
  NEWS_SECTION_PROP,
  ORGS_SECTION_PROP,
  VIEW_SINGLE_RESULT_INTENTION,
  NO_RESULTS_SEE_MORE_INTENTION,
  SEE_RELATED_RESULTS_INTENTION,
};
